import React from 'react';
import './layoutFooter.scss';

import { useTranslation } from 'react-i18next';
import { Facebook, Instagram, Tiktok, TwitterX, Whatsapp, Youtube } from 'react-bootstrap-icons';

import { useThemeContext } from '../../contexts/ThemeContext';
import { Link } from 'react-router-dom';

const socialMediaIcon = (_: string, socialMediaIcon: React.ReactNode, link: string) => {
  return (
    <a key={link} className="cursor-pointer" href={link} target="_blank">
      {socialMediaIcon}
    </a>
  );
};

const LayoutFooter = () => {
  const { t } = useTranslation(['footer']);
  const currentYear = new Date().getFullYear();

  const { activeThemeConfig } = useThemeContext();

  const socialMediaOptions = [
    {
      platformName: t('Facebook'),
      icon: <Facebook size={20} />,
      // link: 'https://www.facebook.com/share/1G1kVNHwm8/?mibextid=wwXIfr',
      link: 'https://www.facebook.com/sde.hn/?fref=ts',
    },
    {
      platformName: t('Whatsapp'),
      icon: <Whatsapp size={20} />,
      // link: 'https://www.whatsapp.com/download?lang=en',
      link: 'https://www.whatsapp.com',
    },
    {
      platformName: t('X'),
      icon: <TwitterX size={20} />,
      // link: 'https://x.com/uftfhonduras?s=21&t=3vUq5oFpQw5k1ac2cd7cFQ',
      link: 'https://twitter.com/SDEHonduras',
    },
    {
      platformName: t('Instagram'),
      icon: <Instagram size={20} />,
      // link: 'https://www.instagram.com/uftf_hn/?igsh=cDlvazR1c2p4aGg5#',
      link: 'https://www.instagram.com/sde.hn/',
    },
    {
      platformName: t('YouTube'),
      icon: <Youtube size={20} />,
      // link: 'https://www.youtube.com/@uftf_hn',
      link: 'https://www.youtube.com/@SDE20243',
    },
    {
      platformName: t('tiktok'),
      icon: <Tiktok size={20} />,
      // link: 'https://www.youtube.com/@uftf_hn',
      link: 'https://www.tiktok.com/@sde_hn',
    },
  ];

  return (
    <>
      <footer className="mb-3 flex flex-col items-center justify-between bg-[#f4f8fc] px-10 pb-20 pt-12 md:flex-row md:items-stretch md:px-16">
        <div className="w-5/6 space-y-2 sm:w-1/3 md:w-auto">
          <img className="h-[66px] w-[186px]" src={activeThemeConfig.LOGO_WITH_NAME} />
          <p className="text-base text-font-color">{t('copyRight', { year: currentYear })}</p>
        </div>

        {/* --- Not implemented yet --- */}
        {/* <div className="mt-6 flex w-5/6 flex-col gap-y-3 sm:w-1/3 md:mt-0 md:w-auto">
          <h3 className="text-headings-font-color">{t('quickLink')}</h3>
          <a className="text-font-color" href="">
            {t('help')}
          </a>
          <a className="text-font-color" href="">
            {t('terms')}
          </a>
          <a className="text-font-color" href="">
            {t('privacy')}
          </a>
          <a className="text-font-color" href="">
            {t('accessability')}
          </a>
        </div> */}

        <div className="mt-6 flex w-5/6 flex-col justify-between sm:w-1/3 md:mt-0 md:!w-2/5">
          <div className="space-y-2">
            <h3 className="text-headings-font-color">{t('contactUs')}</h3>
            <div>
              <a className="text-font-color" href="mailto:https://outlook.office.com/mail">
                {t('email')}: https://outlook.office.com/mail
              </a>
            </div>
            <div>
              <a className="whitespace-nowrap text-font-color" href="tel:+50425588041">
                {t('tel')}: +504 2558-8041
              </a>
            </div>
          </div>

          <div className="mt-6 flex flex-row flex-wrap gap-5 md:gap-10 text-primary md:mt-4">
            {socialMediaOptions.map((item) => {
              return socialMediaIcon(item.platformName, item.icon, item.link);
            })}
          </div>
        </div>
      </footer>
    </>
  );
};

export default LayoutFooter;
